export default __webpack_public_path__ + "static/media/LineIcons.05bb07ee.woff2";